import TextBox from './platform/core/component/TextBox/Component'
import TextField from './platform/component/value/TextField/Component'
import TextArea from './platform/component/value/TextArea/Component'
import Text from './platform/component/value/Text/Component'
import Slider from './platform/component/value/Slider/Component'
import Select from './platform/component/value/Select/Component'
import RadioField from './platform/component/value/RadioField/Component'
import PasswordField from './platform/component/value/PasswordField/Component'
import Option from './platform/component/value/Option/Component'
import NumberField from './platform/component/value/NumberField/Component'
import FileField from './platform/component/value/FileField/Component'
import Fieldset from './platform/component/value/Fieldset/Component'
import EditableField from './platform/component/value/EditableField/Component'
import Color from './platform/component/value/Color/Component'
import Checkbox from './platform/component/value/Checkbox/Component'
import View from './platform/component/svg/View/Component'
import Use from './platform/component/svg/Use/Component'
import TextPath from './platform/component/svg/TextPath/Component'
import Text0 from './platform/component/svg/Text/Component'
import TSpan from './platform/component/svg/TSpan/Component'
import Symbol from './platform/component/svg/Symbol/Component'
import Switch from './platform/component/svg/Switch/Component'
import Stop from './platform/component/svg/Stop/Component'
import Set from './platform/component/svg/Set/Component'
import SVG from './platform/component/svg/SVG/Component'
import Rect from './platform/component/svg/Rect/Component'
import RadialGradient from './platform/component/svg/RadialGradient/Component'
import Polyline from './platform/component/svg/Polyline/Component'
import Polygon from './platform/component/svg/Polygon/Component'
import Pattern from './platform/component/svg/Pattern/Component'
import Path from './platform/component/svg/Path/Component'
import Mask from './platform/component/svg/Mask/Component'
import Marker from './platform/component/svg/Marker/Component'
import MPath from './platform/component/svg/MPath/Component'
import LinearGradient from './platform/component/svg/LinearGradient/Component'
import Line from './platform/component/svg/Line/Component'
import Image from './platform/component/svg/Image/Component'
import Group from './platform/component/svg/Group/Component'
import ForeignObject from './platform/component/svg/ForeignObject/Component'
import FilterEffectTurbulence from './platform/component/svg/FilterEffectTurbulence/Component'
import FilterEffectTile from './platform/component/svg/FilterEffectTile/Component'
import FilterEffectSpotLight from './platform/component/svg/FilterEffectSpotLight/Component'
import FilterEffectSpecularLighting from './platform/component/svg/FilterEffectSpecularLighting/Component'
import FilterEffectPointLight from './platform/component/svg/FilterEffectPointLight/Component'
import FilterEffectOffset from './platform/component/svg/FilterEffectOffset/Component'
import FilterEffectMorphology from './platform/component/svg/FilterEffectMorphology/Component'
import FilterEffectMergeNode from './platform/component/svg/FilterEffectMergeNode/Component'
import FilterEffectMerge from './platform/component/svg/FilterEffectMerge/Component'
import FilterEffectImage from './platform/component/svg/FilterEffectImage/Component'
import FilterEffectGaussianBlur from './platform/component/svg/FilterEffectGaussianBlur/Component'
import FilterEffectFlood from './platform/component/svg/FilterEffectFlood/Component'
import FilterEffectDropShadow from './platform/component/svg/FilterEffectDropShadow/Component'
import FilterEffectDistantLight from './platform/component/svg/FilterEffectDistantLight/Component'
import FilterEffectDisplacementMap from './platform/component/svg/FilterEffectDisplacementMap/Component'
import FilterEffectDiffuseLighting from './platform/component/svg/FilterEffectDiffuseLighting/Component'
import FilterEffectConvolveMatrix from './platform/component/svg/FilterEffectConvolveMatrix/Component'
import FilterEffectComponentTransfer from './platform/component/svg/FilterEffectComponentTransfer/Component'
import FilterEffectColorMatrix from './platform/component/svg/FilterEffectColorMatrix/Component'
import FilterEffectBlend from './platform/component/svg/FilterEffectBlend/Component'
import Filter from './platform/component/svg/Filter/Component'
import Ellipse from './platform/component/svg/Ellipse/Component'
import Defs from './platform/component/svg/Defs/Component'
import ClipPath from './platform/component/svg/ClipPath/Component'
import Circle from './platform/component/svg/Circle/Component'
import AnimateTransform from './platform/component/svg/AnimateTransform/Component'
import AnimateMotion from './platform/component/svg/AnimateMotion/Component'
import Animate from './platform/component/svg/Animate/Component'
import Video from './platform/component/media/Video/Component'
import Image0 from './platform/component/media/Image/Component'
import Audio from './platform/component/media/Audio/Component'
import Canvas from './platform/component/canvas/Canvas/Component'
import Transcend from './platform/component/app/Transcend/Component'
import Search from './platform/component/app/Search/Component'
import Resize from './platform/component/app/Resize/Component'
import PhoneKeyboardKey from './platform/component/app/PhoneKeyboardKey/Component'
import PhoneKeyboard from './platform/component/app/PhoneKeyboard/Component'
import ModeSelector from './platform/component/app/ModeSelector/Component'
import IconButton from './platform/component/app/IconButton/Component'
import GUIControlKeyboard from './platform/component/app/GUIControlKeyboard/Component'
import GUIControl from './platform/component/app/GUIControl/Component'
import GUI from './platform/component/app/GUI/Component'
import Editor from './platform/component/app/Editor/Component'
import Editor0 from './platform/component/Body/Component'
import Editor1 from './platform/component/Anchor/Component'
import Editor2 from './platform/component/Bold/Component'
import Editor3 from './platform/component/Button/Component'
import Editor4 from './platform/component/Details/Component'
import Editor5 from './platform/component/Div/Component'
import Editor6 from './platform/component/Form/Component'
import Editor7 from './platform/component/Header1/Component'
import Editor8 from './platform/component/Header2/Component'
import Editor9 from './platform/component/Header3/Component'
import Editor10 from './platform/component/Label/Component'
import Editor11 from './platform/component/Paragraph/Component'
import Editor12 from './platform/component/Span/Component'
import Editor13 from './platform/component/Summary/Component'
import Editor14 from './platform/component/Table/Component'
import Editor15 from './platform/component/TableData/Component'
import Editor16 from './platform/component/TableHeader/Component'
import Editor17 from './platform/component/TableRow/Component'
import Datum from './platform/component/app/Datum/Component'
import Class from './platform/component/app/Class/Component'
import Bot from './platform/component/app/Bot/Component'
import Zoom from './platform/component/Zoom/Component'
import Wrap from './platform/component/Wrap/Component'
import Section from './platform/component/Section/Component'
import Render from './platform/component/Render/Component'
import Parent from './platform/component/Parent/Component'
import Nav from './platform/component/Nav/Component'
import Inherit from './platform/component/Inherit/Component'
import Icon from './platform/component/Icon/Component'
import Frame from './platform/component/Frame/Component'
import Footer from './platform/component/Footer/Component'
import Article from './platform/component/Article/Component'

export default {
	'9988a56e-6bee-46c8-864c-e351d84bc7e2': TextBox,
	'6a14988f-5f4b-4fab-af32-226b7844e41f': TextField,
	'83ec6688-b80b-4ef2-861f-14245ef392c0': TextArea,
	'87f99b85-1c24-4e5b-a903-dd27230f4092': Text,
	'e06518cf-9edf-430b-8751-74c486e407aa': Slider,
	'6c7cd7d1-c8a0-4317-9c8c-ba781f150729': Select,
	'0f82f52f-0380-46d5-a959-0eebd5de503e': RadioField,
	'51c2c7b4-cb8a-42e8-95ab-14b8ac37700c': PasswordField,
	'c0d13c03-9b10-4a6f-a79f-66294d10aae6': Option,
	'9bc56564-ef4e-11ea-939a-27ae3feb321e': NumberField,
	'e2109627-9783-4664-a70c-858fd8c46ea5': FileField,
	'429496bf-98fa-45e8-81b8-960f4e2546ba': Fieldset,
	'6309ac3f-4a37-4ab0-86c6-8be70b38e31d': EditableField,
	'd8aa573f-129e-4587-9c64-674729d024e2': Color,
	'096fc4ca-edd2-11ea-8266-37b634a3ee0b': Checkbox,
	'4e555154-695c-471a-8a91-47bda70f8110': View,
	'ad12678e-6642-11eb-9fc3-9fbc75c58110': Use,
	'00c828fc-9243-11ea-b897-5b0fc55820c5': TextPath,
	'49ef122e-b4d1-11ea-b45e-b73d8ee2aae8': Text0,
	'e535bcf4-395f-41c7-afa4-01a4861c8859': TSpan,
	'3c629fa2-6cc6-4ebc-b265-80444b446d2b': Symbol,
	'c68b0424-ced2-43b3-ac82-965163579f7e': Switch,
	'56744e26-6909-4432-9849-2c77b0f2f2bf': Stop,
	'224dcb68-db0e-494c-8b91-7e2ebe0051c6': Set,
	'98c279fc-7f5e-11ea-b9e4-f772f9f0bed1': SVG,
	'c0bfe832-8967-11ea-8c4c-1f2995e41b68': Rect,
	'd1c76124-8869-4145-ba30-e3604e928527': RadialGradient,
	'4a06405b-29d6-483e-9ab4-5f659e139e4c': Polyline,
	'e4f85559-b661-49a6-aa90-9191c00e59cd': Polygon,
	'de8e7f1a-3064-4e04-b47e-eb06386ac794': Pattern,
	'60bc7930-8982-11ea-8b24-cf97a783bb32': Path,
	'a9d998f8-4e62-40b0-8c4d-440e39d28ca3': Mask,
	'9932f3bc-9241-11ea-89fa-0b2fdace0f08': Marker,
	'a95746c4-013d-4dd4-8488-fdca75c4757b': MPath,
	'a693fa9e-1ab3-4145-968a-9c234a7df038': LinearGradient,
	'38d26d76-2559-11eb-ae02-dfda9b9b137e': Line,
	'3865cbaf-aac1-4640-b809-c08f979b67f0': Image,
	'be11165e-489f-11eb-921f-87b924eb0725': Group,
	'e049f16e-2559-11eb-bdc4-db5b8a11164b': ForeignObject,
	'be0975fc-a9c7-4d92-a3b9-4479e986c2af': FilterEffectTurbulence,
	'bdce9206-5331-47dd-a111-902ee41f16ce': FilterEffectTile,
	'01193871-ae03-4ab3-9d06-e9956b28e626': FilterEffectSpotLight,
	'e98c55d5-9dce-4ca3-b7e5-08aa6b18eacf': FilterEffectSpecularLighting,
	'1fca03b4-707c-4f16-aeb5-992e55f351c6': FilterEffectPointLight,
	'9023fbd3-8308-4436-a26a-cc19044183e4': FilterEffectOffset,
	'541f7ae5-3db1-4344-8e87-f42e4d1fdfe8': FilterEffectMorphology,
	'1a362a13-9df1-4b22-a9b5-91cdeac1e00f': FilterEffectMergeNode,
	'f87fd33f-c02a-4238-959f-3520611c7903': FilterEffectMerge,
	'bc9e9f08-877a-4814-a33f-ee80c013fca3': FilterEffectImage,
	'8fa07772-cd92-4b7b-b876-29883a27d7c7': FilterEffectGaussianBlur,
	'd94b1e9d-0445-4e54-a549-b79e47a3c7a0': FilterEffectFlood,
	'0c15cd43-6997-4f9f-b52f-acd4c0ed0670': FilterEffectDropShadow,
	'fc78d9fd-45dc-4b01-83d9-8979b5697f56': FilterEffectDistantLight,
	'1e9b1142-bbcf-4627-8cc2-86d5a3bb3dd1': FilterEffectDisplacementMap,
	'fdae0046-d36c-4b21-bb1d-77182d89cadf': FilterEffectDiffuseLighting,
	'7db232f5-870c-418a-8efd-fa9bba6c8c4a': FilterEffectConvolveMatrix,
	'90d0f768-3991-4cd3-9995-07d0dab6d41c': FilterEffectComponentTransfer,
	'6a9360da-a323-4e67-b522-4dbd704483a3': FilterEffectColorMatrix,
	'066655a1-b9ac-4877-a258-53c8a008db0e': FilterEffectBlend,
	'7bc94934-0b91-46ca-bf45-7b5d2918dd6a': Filter,
	'b173c896-4818-46a1-9a5b-ef3a90fea45a': Ellipse,
	'3fcb8e64-923d-11ea-bab1-43fa3b273af8': Defs,
	'8a204a3a-12af-4970-8851-464ebb91342e': ClipPath,
	'7666978e-252c-11eb-97a4-0f3e81286cae': Circle,
	'25f45f9e-1a62-4b96-9347-7ea5bc0af651': AnimateTransform,
	'9140df42-1c5e-4e18-a106-6ad9be30bb55': AnimateMotion,
	'4e97caab-d48d-488e-b56b-4141e68fed85': Animate,
	'7a8921eb-c1ad-400b-94fc-6c6cead8163d': Video,
	'059579bb-184f-435b-ace0-64ec95c9f125': Image0,
	'06823924-b659-4a22-8ed4-b3243121b55d': Audio,
	'94243ec4-8967-4907-8cdd-7223fe256cf6': Canvas,
	'e39a2a34-c71a-11ea-9835-07964acf6760': Transcend,
	'4caaa14d-282f-49a0-832e-c5254735efbf': Search,
	'6b18c608-7b5a-11ea-bb6e-2ff12a5cc3f3': Resize,
	'bc34c618-1c77-11eb-9785-e39a2bf52e49': PhoneKeyboardKey,
	'fcccb9a4-1a30-11eb-93b0-e7d511d031f2': PhoneKeyboard,
	'b4d025e2-811e-11ea-97ee-1bd8d1736e67': ModeSelector,
	'65759894-7d11-11ea-a838-93e14e650d65': IconButton,
	'96d5d60e-85eb-11eb-ba90-7fc42ab0a641': GUIControlKeyboard,
	'c9b62bcc-8196-11eb-8372-9f2ac2c356d4': GUIControl,
	'0f043df2-46fc-11eb-ae20-6f1fedd527ba': GUI,
	'e80c912e-7508-11ea-966b-436805345ff0': Editor,
	'4df9733c-9e3a-4ec2-9473-54ae2172cbe6': Editor0,
	'ccf6d0e2-6b08-11eb-9fc3-3785374109d0': Editor1,
	'cbf8f925-05df-4562-81ed-8cc1ddac6aac': Editor2,
	'b61f5cc6-37e9-45e1-965b-02940820f7ce': Editor3,
	'0ea7279e-9ca2-48ab-8d70-f5333a717dc4': Editor4,
	'66698a97-15c5-4602-9925-11a1aeb03710': Editor5,
	'f59a94c6-4d05-496a-bb36-da5263703ea1': Editor6,
	'dd7616e2-2e64-4d9c-b13e-ca7efeacd982': Editor7,
	'321f971c-b898-4ca4-9e6e-3d75d68940f7': Editor8,
	'b7f043ee-4f9d-4f69-90fe-63b1357ff4c2': Editor9,
	'23b7df22-79e0-4233-8388-7e6e8f1859c6': Editor10,
	'2a5ad480-9d38-4918-8774-41fac7b54203': Editor11,
	'c711d540-9de3-437e-854a-b59491af3cf8': Editor12,
	'58bfcb06-b41d-4205-91f5-c00aff3e209c': Editor13,
	'2168add9-f2f9-4a9d-9af3-5da57705c4f9': Editor14,
	'eff80fbe-2f83-4a59-8576-9ec0c79ce439': Editor15,
	'9487c48c-ab31-45ae-897f-348ec222b35e': Editor16,
	'e7d8b387-3ea7-490e-80da-40af51c9ac4a': Editor17,
	'e8bce1fc-ae56-4f9f-9685-3cc844758855': Datum,
	'c18d7dcc-939b-11ea-90cb-77846d7504a9': Class,
	'0e9e6cd4-67eb-11ea-995b-4b0721193361': Bot,
	'3ffeaaf8-30dd-11eb-9dcc-836b075fc64d': Zoom,
	'454aaff2-cd74-4f6e-baf2-631bb32e7a6b': Wrap,
	'3ea02a11-9b11-46d9-948e-ff0e21e4ba14': Section,
	'7772a2f5-40c8-482e-83f4-bed9bfb364e3': Render,
	'78b0939d-43e1-4f6c-867d-e4217a55d217': Parent,
	'ded3f778-b5f2-4f1f-80cd-7cf8ba18165c': Nav,
	'b5286262-9f92-40d3-8545-88fb3079a0f9': Inherit,
	'63a417e5-d354-4b39-9ebd-05f55e70de7b': Icon,
	'd7c86a2a-489f-11eb-b83e-d3767f6d49b7': Frame,
	'5628f1fb-8c36-4844-b459-89611c07c359': Footer,
	'b7bbde81-0ad8-4719-b1a2-cbaf48bb94a4': Article,
}